import { createAsyncThunk } from '@reduxjs/toolkit';
import type { PlataformaLogsResponse } from '../../types/plataforma';
import { plataformaLogsService } from './services';

export const fetchPlataformaLogs = createAsyncThunk<
  PlataformaLogsResponse,
  void,
  { rejectValue: string }
>('plataformaLogs/fetch', async (_, { rejectWithValue }) => {
  try {
    return await plataformaLogsService.getLogs();
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar logs da plataforma',
    );
  }
});
